import { EKitCheckStatus } from "../interfaces";
import { SPLOOT_BADGE_COLOR } from "../themes";

export const KIT_CHECK_STATUS_COLORS = {
  [EKitCheckStatus.PENDING_REVIEW]: SPLOOT_BADGE_COLOR.GRAY,
  [EKitCheckStatus.APPROVED]: SPLOOT_BADGE_COLOR.GREEN,
  [EKitCheckStatus.REJECTED]: SPLOOT_BADGE_COLOR.RED,
};
